/**
 * Injects the $100 minimum-order notice into Corner Cart (cart drawer)
 * and keeps remaining-amount copy in sync with the live cart.
 */
(function () {
  var CONFIG_ID = 'MinimumOrderNoticeConfig';
  var NOTICE_ATTR = 'data-minimum-order-notice-drawer';
  var HEADER_ID = 'corner-cowi-header';

  function getConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    var abs = Math.abs(cents);
    var amount = (abs / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(abs / 100));
    if (!format) return '$' + amount;
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function buildCopy(config, cart) {
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var remaining = Math.max(config.thresholdCents - total, 0);
    var detail = config.copy.empty;
    var state = 'empty';

    if (count > 0 && remaining > 0) {
      state = 'short';
      detail = config.copy.remaining.replace('__AMOUNT__', formatMoney(remaining, config.moneyFormat));
    } else if (count > 0) {
      state = 'met';
      detail = config.copy.met;
    }

    return {
      required: config.copy.required,
      detail: detail,
      state: state
    };
  }

  function createNotice(copy) {
    var wrap = document.createElement('div');
    wrap.setAttribute(NOTICE_ATTR, 'true');
    wrap.setAttribute('role', 'status');
    wrap.innerHTML =
      '<p class="minimum-order-notice__title"></p>' +
      '<p class="minimum-order-notice__detail"></p>';
    updateNotice(wrap, copy);
    return wrap;
  }

  function noticeClassName(state, isDrawer) {
    var classes = 'minimum-order-notice minimum-order-notice--' + state;
    if (isDrawer) classes += ' minimum-order-notice--drawer';
    return classes;
  }

  function updateNotice(el, copy) {
    var isDrawer = el.hasAttribute(NOTICE_ATTR);
    el.className = noticeClassName(copy.state, isDrawer);
    el.hidden = copy.state === 'met';
    var title = el.querySelector('.minimum-order-notice__title');
    var detail = el.querySelector('.minimum-order-notice__detail');
    if (title) title.textContent = copy.required;
    if (detail) detail.textContent = copy.detail;
  }

  function findDrawerHeaders() {
    return document.querySelectorAll('#' + HEADER_ID);
  }

  function injectIntoDrawers(copy) {
    var headers = findDrawerHeaders();
    for (var i = 0; i < headers.length; i++) {
      var header = headers[i];
      var parent = header.parentNode;
      if (!parent) continue;

      var existing = null;
      var sibling = header.nextElementSibling;
      if (sibling && sibling.hasAttribute && sibling.hasAttribute(NOTICE_ATTR)) {
        existing = sibling;
      } else if (parent.querySelector) {
        existing = parent.querySelector('[' + NOTICE_ATTR + ']');
      }

      if (existing) {
        updateNotice(existing, copy);
        continue;
      }

      parent.insertBefore(createNotice(copy), header.nextSibling);
    }
  }

  function updatePageNotices(copy) {
    var nodes = document.querySelectorAll('[data-minimum-order-notice]');
    for (var i = 0; i < nodes.length; i++) {
      updateNotice(nodes[i], copy);
    }
  }

  function apply(config, cart) {
    var copy = buildCopy(config, cart);
    updatePageNotices(copy);
    injectIntoDrawers(copy);
  }

  function isCartMutation(url, method) {
    if (!url) return false;
    var path = String(url);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(path)) return true;
    return /^post$/i.test(method || '') && /\/cart(\?|$)/i.test(path);
  }

  function init() {
    var config = getConfig();
    if (!config) return;

    var pending = false;
    var readingCart = false;
    var timer = null;
    var lastCart = {
      total_price: config.cartTotalCents,
      item_count: config.itemCount
    };

    function fetchCart() {
      readingCart = true;
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .catch(function () {
          return null;
        })
        .finally(function () {
          readingCart = false;
        });
    }

    function render(cart) {
      if (cart) lastCart = cart;
      apply(config, lastCart);
    }

    function run() {
      if (pending) return;
      pending = true;
      fetchCart()
        .then(function (cart) {
          render(cart);
        })
        .finally(function () {
          pending = false;
        });
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(run, 200);
    }

    render(lastCart);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:change', schedule);

    if (document.body) {
      var observer = new MutationObserver(function () {
        if (findDrawerHeaders().length && !document.querySelector('[' + NOTICE_ATTR + ']')) {
          render(lastCart);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (typeof window.fetch === 'function') {
      var originalFetch = window.fetch;
      window.fetch = function () {
        var result = originalFetch.apply(this, arguments);
        if (readingCart) return result;
        try {
          var input = arguments[0];
          var init = arguments[1] || {};
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var method = init.method || (input && input.method) || 'GET';
          if (isCartMutation(url, method)) {
            result.then(function () { schedule(); }).catch(function () {});
          }
        } catch (error) {
          // Ignore fetch-wrapper parse errors
        }
        return result;
      };
    }

    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
      var originalOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__minOrderUrl = url;
        this.__minOrderMethod = method;
        return originalOpen.apply(this, arguments);
      };
      var originalSend = window.XMLHttpRequest.prototype.send;
      window.XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        xhr.addEventListener('load', function () {
          if (!readingCart && isCartMutation(xhr.__minOrderUrl, xhr.__minOrderMethod)) {
            schedule();
          }
        });
        return originalSend.apply(this, arguments);
      };
    }
  }

  init();
})();
